/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class Session {
    constructor(user) {
        this.user = user;
    }
}

export { Session };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/Session.js